import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a0e1c62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "strategy-details-container" }
const _hoisted_2 = { class: "card strategy-yield-card" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "策略收益(模拟)", -1))
const _hoisted_4 = { class: "yield-stats" }
const _hoisted_5 = { class: "stat-item" }
const _hoisted_6 = { class: "stat-value rise-text" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "平均胜率", -1))
const _hoisted_8 = { class: "stat-item" }
const _hoisted_9 = { class: "stat-value neutral-text" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "盈亏比", -1))
const _hoisted_11 = { class: "stat-item" }
const _hoisted_12 = { class: "stat-value neutral-text" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "最大回撤", -1))
const _hoisted_14 = { class: "card-header logic-card-header" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "策略逻辑说明", -1))
const _hoisted_16 = { class: "logic-body" }
const _hoisted_17 = {
  key: 0,
  class: "logic-section"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "策略介绍", -1))
const _hoisted_19 = { class: "logic-list" }
const _hoisted_20 = { class: "logic-item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "策略名称", -1))
const _hoisted_22 = { class: "value" }
const _hoisted_23 = { class: "logic-item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "策略介绍", -1))
const _hoisted_25 = { class: "value" }
const _hoisted_26 = {
  key: 1,
  class: "logic-section"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "选股因子", -1))
const _hoisted_28 = { class: "logic-list" }
const _hoisted_29 = { class: "label" }
const _hoisted_30 = { class: "value" }
const _hoisted_31 = {
  key: 2,
  class: "logic-section"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "选股范围", -1))
const _hoisted_33 = { class: "logic-list" }
const _hoisted_34 = { class: "label" }
const _hoisted_35 = { class: "value" }
const _hoisted_36 = { class: "logic-section" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "买卖规则", -1))
const _hoisted_38 = { class: "logic-list" }
const _hoisted_39 = { class: "logic-item" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "买入规则", -1))
const _hoisted_41 = { class: "value" }
const _hoisted_42 = { class: "logic-item" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "卖出规则", -1))
const _hoisted_44 = { class: "value" }
const _hoisted_45 = { class: "logic-section" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "仓位控制", -1))
const _hoisted_47 = { class: "logic-list" }
const _hoisted_48 = { class: "logic-item" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "初始资金", -1))
const _hoisted_50 = { class: "value" }
const _hoisted_51 = { class: "logic-item" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "个股最大持仓", -1))
const _hoisted_53 = { class: "value" }
const _hoisted_54 = { class: "logic-item" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "账户最大持股数", -1))
const _hoisted_56 = { class: "value" }
const _hoisted_57 = { class: "logic-item" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "单日最大买入数", -1))
const _hoisted_59 = { class: "value" }
const _hoisted_60 = { class: "logic-section" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "回测周期", -1))
const _hoisted_62 = { class: "logic-list" }
const _hoisted_63 = { class: "logic-item" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "回测周期", -1))
const _hoisted_65 = { class: "value" }
const _hoisted_66 = {
  key: 1,
  class: "stock-logic-box"
}
const _hoisted_67 = { class: "stock-logic-header" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stock-logic-title" }, "策略逻辑说明", -1))
const _hoisted_69 = {
  key: 0,
  class: "stock-logic-row"
}
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "stock-logic-label" }, "策略风格", -1))
const _hoisted_71 = { class: "stock-logic-value" }
const _hoisted_72 = { class: "stock-logic-row" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "stock-logic-label" }, "买入信号", -1))
const _hoisted_74 = { class: "stock-logic-value" }
const _hoisted_75 = { class: "stock-logic-row" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "stock-logic-label" }, "卖出信号", -1))
const _hoisted_77 = { class: "stock-logic-value" }

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import StarTemplateLockMask from '@/components/star/StarTemplateLockMask.vue'
import { useStarRouter } from '@/utils/useStarTheme'
import type { TemplateLockState } from '@/utils/useStarTemplateLock'


export default /*#__PURE__*/_defineComponent({
  __name: 'StrategyDetails',
  props: {
    strategyDetails: null,
    isDark: { type: Boolean },
    isFactor: { type: Boolean },
    isStock: { type: Boolean },
    isAi: { type: Boolean },
    strategyTab: null,
    useComTemplateResult: { type: Boolean },
    logicLockState: null
  },
  emits: ["unlock"],
  setup(__props: any, { emit }: { emit: ({ (e: 'unlock'): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
  strategyDetails: any
  isDark: boolean
  isFactor: boolean
  isStock?: boolean
  isAi?: boolean
  strategyTab?: string
  /** 模版策略详情：策略逻辑说明取 comTemplateResult.req */
  useComTemplateResult?: boolean
  /** 体验用户：策略逻辑说明锁定状态 */
  logicLockState?: TemplateLockState
}



const route = useRoute()
const { starPush } = useStarRouter()



const logicReq = computed(() => {
  if (props.useComTemplateResult) {
    return props.strategyDetails?.comTemplateResult?.req
  }
  return props.strategyDetails?.comResult?.req
})

/** 一键回测（isocbt=1）、回测记录（fromRecord=1）进入结果页不展示复制策略；模版策略详情在底部展示 */
const showCopyStrategy = computed(
  () =>
    route.query.isocbt !== '1' &&
    route.query.fromRecord !== '1' &&
    !props.useComTemplateResult,
)

const handleCopyStrategy = () => {
  const taskID = (route.query.taskID as string) || ''
  if (!taskID) return
  if (props.isStock) {
    starPush('/star/stock', { copyTaskID: taskID })
  } else {
    starPush('/star/group', { watchWord: taskID })
  }
}

const formatPercent = (val: number | undefined) => {
  if (val == null) return '--'
  const pct = val * 100
  return (pct > 0 ? '' : '') + pct?.toFixed(2) + '%'
}
const formatPercentbujiwei = (val: number | undefined) => {
  if (val == null) return '--';
  // 放大10000倍取整规避浮点误差，再截断后两位
  const num = Math.trunc(val * 10000) / 100;
  return num.toFixed(2) + '%';
};
const formatNumber = (val: number | undefined, decimals: number) => {
  if (val === undefined || val == null) return '--'
  const factor = Math.pow(10, decimals)
  const truncated = Math.trunc(val * factor) / factor
  return truncated.toFixed(decimals)
}

const getColorClass = (val: number | undefined) => {
  if (val === undefined) return 'neutral-text'
  if (val > 0) return 'rise-text'
  if (val < 0) return 'fall-text'
  return 'neutral-text'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["yield-value", getColorClass(__props.strategyDetails.summary?.cumRet)])
      }, _toDisplayString(formatPercentbujiwei(__props.strategyDetails.summary?.cumRet)), 3),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(formatPercentbujiwei(__props.strategyDetails.summary?.winRate)), 1),
          _hoisted_7
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(formatNumber(__props.strategyDetails.summary?.plRatio, 3)), 1),
          _hoisted_10
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, _toDisplayString(formatPercentbujiwei(__props.strategyDetails.summary?.maxDD)), 1),
          _hoisted_13
        ])
      ])
    ]),
    (!__props.isStock)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["card strategy-logic-card strategy-logic-lock-wrap", { 'strategy-logic-card--locked': __props.logicLockState === 'locked' || __props.logicLockState === 'pending' }])
        }, [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            (_unref(showCopyStrategy))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "copy-strategy-btn",
                  onClick: handleCopyStrategy
                }, "复制策略"))
              : _createCommentVNode("", true)
          ]),
          _createVNode(StarTemplateLockMask, {
            "lock-state": __props.logicLockState,
            text: "解锁策略逻辑说明",
            compact: "",
            class: "logic-body-lock",
            onUnlock: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('unlock')))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_16, [
                (_unref(logicReq)?.isWatchWord)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _hoisted_21,
                          _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(logicReq)?.strategyName || '--'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _hoisted_24,
                          _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(logicReq)?.strategyNote || '--'), 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(logicReq)?.factorBuy?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _hoisted_27,
                      _createElementVNode("div", _hoisted_28, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(logicReq)?.factorBuy, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "logic-item",
                            key: index
                          }, [
                            _createElementVNode("span", _hoisted_29, _toDisplayString(item.nameShow), 1),
                            _createElementVNode("span", _hoisted_30, _toDisplayString(item.valueShow), 1)
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(logicReq)?.stockRange?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _hoisted_32,
                      _createElementVNode("div", _hoisted_33, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(logicReq)?.stockRange, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "logic-item",
                            key: index
                          }, [
                            _createElementVNode("span", _hoisted_34, _toDisplayString(item.nameShow), 1),
                            _createElementVNode("span", _hoisted_35, _toDisplayString(item.valueShow), 1)
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_36, [
                  _hoisted_37,
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _hoisted_40,
                      _createElementVNode("span", _hoisted_41, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(logicReq)?.ruleBuy, (rule, idx) => {
                          return (_openBlock(), _createElementBlock("div", { key: idx }, _toDisplayString(rule || '--'), 1))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _hoisted_43,
                      _createElementVNode("span", _hoisted_44, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(logicReq)?.ruleSell, (rule, idx) => {
                          return (_openBlock(), _createElementBlock("div", { key: idx }, _toDisplayString(rule || '--'), 1))
                        }), 128))
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _hoisted_46,
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _hoisted_49,
                      _createElementVNode("span", _hoisted_50, _toDisplayString(_unref(logicReq)?.initialFund || '--'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _hoisted_52,
                      _createElementVNode("span", _hoisted_53, _toDisplayString(_unref(logicReq)?.positionLimit || '--'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_54, [
                      _hoisted_55,
                      _createElementVNode("span", _hoisted_56, _toDisplayString(_unref(logicReq)?.maxHolds || '--'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _hoisted_58,
                      _createElementVNode("span", _hoisted_59, _toDisplayString(_unref(logicReq)?.dayLimit || '--'), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _hoisted_61,
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, [
                      _hoisted_64,
                      _createElementVNode("span", _hoisted_65, _toDisplayString(_unref(logicReq)?.period || '--'), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["lock-state"])
        ], 2))
      : _createCommentVNode("", true),
    (__props.isStock)
      ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
          _createElementVNode("div", _hoisted_67, [
            _hoisted_68,
            (_unref(showCopyStrategy))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "copy-strategy-btn",
                  onClick: handleCopyStrategy
                }, "复制策略"))
              : _createCommentVNode("", true)
          ]),
          (__props.isAi)
            ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                _hoisted_70,
                _createElementVNode("span", _hoisted_71, _toDisplayString({ 'best-winrate': '低波动，求稳，适合防守', 'best-yield': '高弹性，求利，适合进攻', 'best-ratio': '全维度，求全，适合配置' }[props.strategyTab || ''] || '--'), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_72, [
            _hoisted_73,
            _createElementVNode("span", _hoisted_74, _toDisplayString((__props.isAi
            ? (__props.strategyDetails.req?.factorBuy || [])
            : (__props.strategyDetails.customResult?.req?.factorBuy || [])
          ).join('；') || '--'), 1)
          ]),
          _createElementVNode("div", _hoisted_75, [
            _hoisted_76,
            _createElementVNode("span", _hoisted_77, _toDisplayString((__props.isAi
            ? (__props.strategyDetails.req?.factorSell || [])
            : (__props.strategyDetails.customResult?.req?.factorSell || [])
          ).join('；') || '--'), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})